// extracted by mini-css-extract-plugin
module.exports = {"otpInput":"style_otpInput__3vKJn","otpInput_item":"style_otpInput_item__2nmtM","otpInput_input":"style_otpInput_input__3F_Fc"};